import { useCheckoutOnepageOffersContext } from "@CheckoutOnepageOffers/provider/useCheckoutOnepageOffersContext";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

import { Container, Paragraph, Strong, TimerIcon } from "./styles";

interface ITimer {
  days: number | string;
  hours: number | string;
  minutes: number | string;
  seconds: number | string;
}

const Countdown = () => {
  const router = useRouter();
  const { offer } = useCheckoutOnepageOffersContext();

  if (
    !offer.offer.details.show_end_countdown ||
    !offer.offer.details.enable_duration
  )
    return null;

  const [timer, setTimer] = useState<ITimer>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const getTimer = () => {
    const deadline = new Date(offer.offer.details.duration_end).getTime();
    const now = new Date().getTime();

    const rest = deadline - now;

    if (rest > 0) {
      const days = Math.floor(rest / (1000 * 60 * 60 * 24))
        .toString()
        .padStart(2, "0");
      const hours = Math.floor(
        (rest % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((rest % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((rest % (1000 * 60)) / 1000);

      setTimer({
        days,
        hours,
        minutes,
        seconds,
      });
    }
  };

  const interval = setInterval(getTimer, 1000);

  useEffect(() => {
    const deadline = new Date(offer.offer.details.duration_end).getTime();
    const now = new Date().getTime();

    const rest = deadline - now;

    if (rest === 0) {
      clearInterval(interval);

      const uuid = router.query.uuid;

      router.push(`/payment/g/${uuid}/closed`);
    }
  }, [timer]);

  return (
    <Container>
      <TimerIcon variant="Bold" />

      <Paragraph>Oferta por tempo limitado</Paragraph>

      <Strong>
        {timer.days}:{timer.hours.toString().padStart(2, "0")}:
        {timer.minutes.toString().padStart(2, "0")}:
        {timer.seconds.toString().padStart(2, "0")}
      </Strong>
    </Container>
  );
};

export default Countdown;
